export default {
    path: '/display/main/list',
    component: () => import('@/layout/default'),
    children: [
        {
            path: '/',
            component: () => import('@/pages/display/main/list/index.vue')
        }
    ]
};
